import FormGroupRenderer, {
  ILabelColumnSize,
} from '@app/components/FormGroupRenderer'
import { IDemographics } from '@app/models/Demographics'
import {
  formatCurrency,
  formatDate,
  formatNumber,
} from '@app/utils/formatting'
import * as React from 'react'

interface IDemographicsViewProps {
  className?: string
  demographics: IDemographics
  style?: React.CSSProperties
}

export default class DemographicsView extends React.PureComponent<
  IDemographicsViewProps
> {
  public render() {
    const demographics = this.props.demographics

    const labelColSizes: ILabelColumnSize = {
      md: 6,
    }

    return (
      <div className={this.props.className} style={this.props.style}>
        <FormGroupRenderer
          className='mb-0'
          labelColSizes={labelColSizes}
          labelText={`${demographics.latestPopulation.year} Population${
            demographics.latestPopulation.estimated ? ' Estimate' : ''
          }`}
        >
          {formatNumber(demographics.latestPopulation.value, 0)}
        </FormGroupRenderer>
        <FormGroupRenderer
          className='mb-0'
          labelColSizes={labelColSizes}
          labelText={`${demographics.lastCensusPopulation.year} Population`}
        >
          {formatNumber(demographics.lastCensusPopulation.value, 0)}
        </FormGroupRenderer>
        <FormGroupRenderer
          className='mb-0'
          labelColSizes={labelColSizes}
          labelText={`Population growth since ${
            demographics.populationGrowth.year
          }`}
        >
          {formatNumber(demographics.populationGrowth.value, 1)} %
        </FormGroupRenderer>
        <FormGroupRenderer
          className='mb-0'
          labelColSizes={labelColSizes}
          labelText={`Median household income in ${
            demographics.avgHouseholdIncome.year
          } dollars`}
        >
          {formatCurrency(demographics.avgHouseholdIncome.value, 0)}
        </FormGroupRenderer>
        <FormGroupRenderer
          className='mb-0'
          labelColSizes={labelColSizes}
          labelText='Median age'
        >
          {formatNumber(demographics.medianAge.value, 1)} years
        </FormGroupRenderer>
        <div className='small'>
          Last updated{' '}
          {formatDate(demographics.lastUpdated, 'MMMM D, YYYY h:mm a')}
        </div>
      </div>
    )
  }
}
